import { render } from "./DropdownMenuItem.vue?vue&type=template&id=6ff065cc"
import script from "./DropdownMenuItem.vue?vue&type=script&lang=js"
export * from "./DropdownMenuItem.vue?vue&type=script&lang=js"

import exportComponent from "/web/markle/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"DropdownMenuItem.vue"]])

export default __exports__